// 📄 components/StepInvoiceTax.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { InvoiceFormData } from '../../../../../services/commerce/integrationService';

interface StepInvoiceTaxProps {
  companyCodeEdi: string;
  taxMappingNotes: string;
  onChange: (field: keyof InvoiceFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepInvoiceTax({ companyCodeEdi, taxMappingNotes, onChange, isInvalid }: StepInvoiceTaxProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">WE20 / FTXP</span>
          <span>Partner Profile (EDI Partner) → Company Code Assignment; Financial Accounting → Tax on Sales/Purchases → Define Tax Codes</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Assign Company Code & Tax Codes</h3>
        <p className="text-sm text-gray-400">
          Asigna el Company Code al Partner EDI que recibe la factura y documenta la conversión de las tasas de impuesto externas (VAT / IVA) a los códigos de impuesto internos de SAP.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Company Code para Partner EDI <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={companyCodeEdi}
            onChange={(e) => onChange('companyCodeEdi', e.target.value.toUpperCase())}
            placeholder="ej. QASCLNT200 / QS4CLNT200"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !companyCodeEdi ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Conversión de Tasas de Impuesto (Externo → SAP)</label>
          <textarea
            value={taxMappingNotes}
            onChange={(e) => onChange('taxMappingNotes', e.target.value)}
            placeholder={"ej. PE (18%) -> C1\nIVA (19%) -> C2"}
            rows={3}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 resize-y"
          />
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Mapeo obligatorio por país</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Cada código de impuesto externo recibido en el cXML debe tener una entrada de conversión — de lo contrario la factura será rechazada por código de impuesto no reconocido.
          </p>
        </div>
      </div>
    </div>
  );
}
